import { render, staticRenderFns } from "./edit-region-popup.vue?vue&type=template&id=5ad34712"
import script from "./edit-region-popup.vue?vue&type=script&lang=js"
export * from "./edit-region-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports